// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ProxReceipt } from './prox-receipt';
import { ProxReceiptStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProxReceiptStatus extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Enum key */
  id!: ProxReceiptStatusEnum;
  /** String(50) */
  name!: string;
  /** Inv FK proxReceiptStatusId */
  proxReceipts!: ProxReceipt[];
}

